import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Pastors from "@/components/site/Pastors";
import Ministries from "@/components/site/Ministries";
import ServiceTimes from "@/components/site/ServiceTimes";
import Sermons from "@/components/site/Sermons";
import GiveBand from "@/components/site/GiveBand";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#050505] text-white antialiased selection:bg-[#4169E1] selection:text-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Pastors />
        <Ministries />
        <ServiceTimes />
        <Sermons />
        <GiveBand />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
      <div className="grain" aria-hidden="true" />
    </div>
  );
}

export default App;
